export default __webpack_public_path__ + "static/media/Rachel.71f84326.jpeg";